module.exports = __webpack_public_path__ + "static/media/package.cdad8aa2.png";